import {buildUrl} from '../../utils/url'
import {
  PaymentSettingsIdType,
  type PaymentSettingsParamsInput
} from '../types/paymentSettings'

type BuildPaymentSettingsEndpoint = ({
  id,
  idType,
  userCountry,
  baseUrl
}: {
  id: string
  idType: PaymentSettingsIdType
  userCountry?: string
  baseUrl: string
}) => string

/**
 * Prepares id and idType required for buildPaymentSettingsEndpoint
 * @param params - Object containing one of 3 types of identifiers: offerToken, bundleId and bookingId
 * @param params.offerToken - For regular offers
 * @param params.bundleId - For splitBooking
 * @param params.bookingId - For existing booking
 * @returns object containing id and idType
 */
export const getPaymentSettingsParamsInput = ({
  offerToken,
  bundleId,
  bookingId
}: {
  offerToken?: string
  bundleId?: string
  bookingId?: string
}): PaymentSettingsParamsInput => {
  const id = offerToken || bundleId || bookingId || ''
  if (bundleId) return {id, idType: PaymentSettingsIdType.Bundle}
  if (bookingId) return {id, idType: PaymentSettingsIdType.Booking}
  return {id, idType: PaymentSettingsIdType.Regular}
}
/**
 * Builds the payment methods endpoint URL based on the provided parameters.
 * Filters out undefined values and constructs the correct API path.
 * @param id - param value: identifier string
 * @param idType - param key: one of offerToken, bundleId or bookingId
 * @param userCountry - override user country available from url
 * @param baseUrl - Base URL for BoVio API.
 * @returns The constructed payment methods URL or null if required parameters are missing.
 */
export const buildPaymentSettingsEndpoint: BuildPaymentSettingsEndpoint = ({
  id,
  idType,
  userCountry,
  baseUrl
}) => {
  return buildUrl(`${baseUrl}payment-methods-settings`, {
    [idType]: id,
    userCountry
  })
}
